import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @todo: If necessary, provide styles for the "b" tag */ var important = function(content) {
    return /*#__PURE__*/ _jsx("b", {
        children: content
    });
};
export { important };
